import { Typography } from '@mui/material';
import { Translate } from 'react-localize-redux';

import type { BmiView } from './normaliseInitialListElements';
import { bmiParts } from './bmiEntry';

/**
 * SHER-1045 — stacked display of a saved BMI value, shared by the form summary
 * (SmartFields/index.tsx) and the patient record view (show_records_section.jsx).
 * Shows only what was recorded: the IMC line exists only when there is an IMC.
 */
export default function BmiSummary({ view }: { view: BmiView }) {
    const parts = bmiParts(view);
    if (parts.bmi == null && parts.height == null && parts.weight == null) {
        return <Typography variant="body2">—</Typography>;
    }
    return (
        <>
            {parts.bmi != null && (
                <Typography variant="body2"><b>IMC:</b> {parts.bmi}</Typography>
            )}
            {parts.height != null && (
                <Typography variant="body2"><b><Translate id="hospital.bmi-height" />:</b> {parts.height}</Typography>
            )}
            {parts.weight != null && (
                <Typography variant="body2"><b><Translate id="hospital.bmi-weight" />:</b> {parts.weight}</Typography>
            )}
        </>
    );
}
